if (!customElements.get("mrk-addon")) {
  class mrkAddon extends HTMLElement {
    connectedCallback() {
      this.addonCheckbox = this.querySelector('.mrk-addon__checkbox');
      this.input = this.querySelector('input[type="text"]');
      this.addonCheckbox.addEventListener("change", () =>
        this.synchronizeProperties()
      );
      this.input.addEventListener("input", () =>{
          this.text = this.input.value;
          this.querySelector('.mrk_hidden_variant_text').value = this.text;
        }
      );
    }
    synchronizeProperties() {
      var form_id = this.querySelector('.mrk-variant-id').getAttribute('data-form');
      if (this.addonCheckbox.checked) {
        this.querySelector('.mrk-addon-data').style.display = 'block';
        this.querySelector('.mrk-variant-id').setAttribute('form', form_id);
        this.querySelector('.mrk_hidden_variant_text').setAttribute('form', form_id);
        this.querySelector('.mrk-parent-id').setAttribute('form', form_id);
      }else{
        this.querySelector('.mrk-addon-data').style.display = 'none';
        this.querySelector('.mrk-variant-id').removeAttribute('form');
        this.querySelector('.mrk_hidden_variant_text').removeAttribute('form');
        this.querySelector('.mrk-parent-id').removeAttribute('form');
      }
    }
  }

  customElements.define("mrk-addon", mrkAddon);
}
